import React from "react";

export default function SquareBg({
  className,
  color = "#000000",
  onClick,
}: {
  className: string;
  color?: string;
  onClick?: () => void;
}) {
  return (
    <div className={`${className}`} onClick={onClick}>
      <svg
        width="159"
        height="159"
        viewBox="0 0 159 159"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M150.325 150.325H159V8.67482H150.325V0H8.67482V8.67482H0V150.325H8.67482V159H150.325V150.325Z"
          fill={color}
        />
      </svg>
    </div>
  );
}
